var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSucces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1d7298dd": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.265,
    height: 151.265,
    viewBox: "0 0 151.265 151.265",
    className: "mb-5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-v-1d7298dd": "",
    id: "Rectangle_1976",
    "data-name": "Rectangle 1976",
    width: 151.265,
    height: 151.265,
    rx: 75.633,
    fill: "#ec7027",
    opacity: 0.625
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-v-1d7298dd": "",
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    width: 109.34,
    height: 109.34,
    rx: 54.67,
    transform: "translate(20.964 20.963)",
    fill: "#e1591f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-1d7298dd": "",
    id: "check",
    transform: "translate(50.688 57.481)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-v-1d7298dd": "",
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M48.429,8.523,22.11,34.841a4.994,4.994,0,0,1-7.061,0L1.462,21.254a4.993,4.993,0,0,1,7.061-7.062L18.58,24.249,41.367,1.462a4.993,4.993,0,0,1,7.062,7.061Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucces);
export default __webpack_public_path__ + "static/media/succes.95989d4a319adbfa7b251a622edf7b30.svg";
export { ForwardRef as ReactComponent };